import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALPEIL,
  DELETE_LEGALPEIL,
  UPDATE_LEGALPEIL,
  ADD_NEW_LEGALPEIL,
} from "./actionType";

import {
  getLegalPeilSuccess,
  getLegalPeilFail,
  deleteLegalPeilSuccess,
  deleteLegalPeilFail,
  updateLegalPeilSuccess,
  updateLegalPeilFail,
  addLegalPeilSuccess,
  addLegalPeilFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalPeilApi,
  updateLegalPeilApi,
  deleteLegalPeilApi,
  addNewLegalPeilApi
} from "../../helpers/backend_helper";

function* getLegalPeil({ payload: legalPeil }) {
  try {
    const response = yield call(getLegalPeilApi, legalPeil);
    yield put(getLegalPeilSuccess(GET_LEGALPEIL, response.data));
  } catch (error) {
    yield put(getLegalPeilFail(GET_LEGALPEIL, error));
  }
}

function* onUpdateLegalPeil({ payload: legalPeil }) {
  try {
    const response = yield call(updateLegalPeilApi, legalPeil);
    yield put(updateLegalPeilSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalPeilFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalPeil({ payload: legalPeil }) {
  try {
    const response = yield call(deleteLegalPeilApi, legalPeil);
    yield put(deleteLegalPeilSuccess({ legalPeil, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalPeilFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalPeil({ payload: legalPeil }) {
  try {
    const response = yield call(addNewLegalPeilApi, legalPeil);
    yield put(addLegalPeilSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalPeilFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalPeil() {
  yield takeEvery(GET_LEGALPEIL, getLegalPeil);
}

export function* watchUpdateLegalPeil() {
  yield takeEvery(UPDATE_LEGALPEIL, onUpdateLegalPeil);
}

export function* watchDeleteLegalPeil() {
  yield takeEvery(DELETE_LEGALPEIL, onDeleteLegalPeil);
}

export function* watchAddNewLegalPeil() {
  yield takeEvery(ADD_NEW_LEGALPEIL, onAddNewLegalPeil);
}

function* legalPeilSaga() {
  yield all([
    fork(watchGetLegalPeil),
    fork(watchDeleteLegalPeil),
    fork(watchUpdateLegalPeil),
    fork(watchAddNewLegalPeil)
  ]);
}

export default legalPeilSaga;
